module.exports = __webpack_public_path__ + "static/background-top-sm-c96d1364fa111ac978ef2a9ee209969e.svg";